import BirthdaysList from "./BirthdaysList";

export default BirthdaysList;
